export const PHRASE_REGEX = /^[a-zA-Z0-9_ À-ÖØ-öø-ÿ]*$/;
export const PHRASE_MIN_LENGTH = 2;
export const PHRASE_MAX_LENGTH = 50;

const getPhrases = (data, element_type) => {
    if (element_type === "entry_phrases") {
        if (!data.info.entry_phrases) {
            data.info.entry_phrases = [];
        }
        return data.info.entry_phrases;
    }
    return data.info.back_to_bot.key_words;
};

const cleanPhrase = (phrase) => (phrase || "").trim().replace(/\s+/g, " ");

const isValidPhrase = (phrase, phrases) => phrase.length >= PHRASE_MIN_LENGTH && phrase.length <= PHRASE_MAX_LENGTH &&
    PHRASE_REGEX.test(phrase) && !phrases.includes(phrase);

export const updateVerneData = (data, e, type) => {
    switch (type) {
        case "capture":
            data.info.capture = {enabled: Boolean(e?.target?.checked)};
            break;
        default:
            data.info[type] = e?.target?.value;
            break;
    }
    return data;
};

export const updateVernePhrases = (data, value, e, type, chipToDelete, i, element_type = "key_words") => {
    const phrases = getPhrases(data, element_type);

    switch (type) {
        case "add": {
            const typed = e.target.value;
            if (PHRASE_REGEX.test(typed) && typed.length <= PHRASE_MAX_LENGTH) {
                return {data, value: typed};
            }
            return null;
        }
        case "delete":
            if (phrases[i] === chipToDelete) {
                phrases.splice(i, 1);
            }
            return {data, value};
        case "enter": {
            const phrase = cleanPhrase(e.target.value);
            if (isValidPhrase(phrase, phrases)) {
                phrases.push(phrase);
                return {data, value: ""};
            }
            return null;
        }
        default:
            return null;
    }
};

export const addPendingPhrase = (data, value, element_type = "key_words") => {
    const phrases = getPhrases(data, element_type);
    const phrase = cleanPhrase(value);

    if (isValidPhrase(phrase, phrases)) {
        phrases.push(phrase);
    }
    return data;
};

export const isVerneComplete = (data, pendingEntryPhrase, pendingExitPhrase) => {
    const info = data?.info;
    if (!info?.base_url?.trim() || !info?.api_key?.trim()) {
        return false;
    }
    const hasPhrase = (phrases, pending) => phrases.length > 0 || isValidPhrase(cleanPhrase(pending), phrases);
    return hasPhrase(info.entry_phrases ?? [], pendingEntryPhrase) &&
        hasPhrase(info.back_to_bot?.key_words ?? [], pendingExitPhrase);
};
